import axios from "@shared/axios";
import LostItem from "@shared-models/box/lost.item.model";

async function getLostItems(): Promise<{ data: any, unread: number }>
{
	const response = await axios.get(
		`/box/lost-items`,
	);

	return response?.data as { data: any, unread: number } ?? null;
}

async function getLostItem(lostItemId: string): Promise<LostItem>
{
	const response = await axios.get(
		`/box/lost-items/${ lostItemId }`,
	);

	return response?.data as LostItem ?? null;
}

async function confirmLostItemOwnership(lostItem: LostItem, proof: string | undefined | null)
{
	const response = await axios.put(
		`/box/lost-items/${ lostItem?.id }/confirm-ownership`,
		{
			"proof": proof
		}
	);

	return response?.data ?? null;
}

async function rollbackLostItemOwnership(lostItem: LostItem)
{
	const response = await axios.put(
		`/box/lost-items/${ lostItem?.id }/rollback-ownership`
	);

	return response?.data ?? null;
}

async function getUnreadLostItemsUserCount(): Promise<number>
{
	const response = await axios.get(
		"/box/lost-items/unread-count"
	);

	return response?.data ?? 0;
}

async function getPendingLostItemsCount(): Promise<number>
{
	const response = await axios.get(
		"/box/lost-items/pending-count"
	);

	return response?.data ?? 0;
}

export {
	getLostItems,
	getLostItem,
	getUnreadLostItemsUserCount,
	confirmLostItemOwnership,
	rollbackLostItemOwnership,
	getPendingLostItemsCount
};
